import { apiClient, ApiResponse } from './api-client'

export interface LoginDTO {
  phoneNumber: string
  password: string
}

export interface RegisterDTO {
  phoneNumber: string
  name: string
  email?: string
  password: string
}

export interface AuthResult {
  user: any
  token: string
  refreshToken?: string
  expiresAt?: string
}

export class AuthService {
  /**
   * Register new user
   */
  async register(data: RegisterDTO): Promise<AuthResult> {
    const response = await apiClient.post<ApiResponse<AuthResult>>('/auth/register', data)
    if (response.data.success && response.data.data) {
      return response.data.data
    }
    throw new Error(response.data.error?.message || 'Registration failed')
  }

  /**
   * Login user (works for all user roles: business_owner, system_admin, monitor, etc.)
   */
  async login(phoneNumber: string, password: string): Promise<AuthResult> {
    const response = await apiClient.post<ApiResponse<AuthResult>>('/auth/login', { phoneNumber, password })
    if (response.data.success && response.data.data) {
      return response.data.data
    }
    throw new Error(response.data.error?.message || 'Login failed')
  }

  /**
   * Logout user
   */
  async logout(): Promise<void> {
    const response = await apiClient.post<ApiResponse>('/auth/logout')
    if (!response.data.success) {
      throw new Error(response.data.error?.message || 'Logout failed')
    }
  }

  /**
   * Refresh access token
   */
  async refreshToken(refreshToken: string): Promise<AuthResult> {
    const response = await apiClient.post<ApiResponse<AuthResult>>('/auth/refresh', { refreshToken })
    if (response.data.success && response.data.data) {
      return response.data.data
    }
    throw new Error(response.data.error?.message || 'Token refresh failed')
  }

}

// Export singleton instance
export const authService = new AuthService()

